export default "__VITE_ASSET__kUXRVJMp__"